import { render } from "./TimerButton.vue?vue&type=template&id=54f07516&scoped=true"
import script from "./TimerButton.vue?vue&type=script&lang=js"
export * from "./TimerButton.vue?vue&type=script&lang=js"

import "./TimerButton.vue?vue&type=style&index=0&id=54f07516&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f07516"]])

export default __exports__